import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useSearchParams } from "react-router-dom";
import { useFormsFilters } from "../hooks/useFormsFilters";
import moment, { type Moment } from "moment";
import { cmmsTheme } from "@setup/theme/cmms-theme";
import { useDateFilterDraft } from "@/shared/hooks/useDateFilterDraft";

type Props = {};

export const EndFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const { start: Start, end: End } = useFormsFilters();

	const handleDateChange = (datePicker: Moment) => {
		if (datePicker.toDate() < Start) {
			return;
		}

		searchParams.set("end", encodeURIComponent(datePicker.toISOString()));
		setSearchParams(searchParams, { replace: true });
	};

	const { pickerProps, textFieldProps } = useDateFilterDraft(
		moment(End),
		handleDateChange,
	);

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DatePicker
				format="MM/DD/YYYY"
				label="End"
				{...pickerProps}
				minDate={moment(Start)}
				slotProps={{
					textField: {
						...textFieldProps,
						fullWidth: true,
						variant: "outlined",
						margin: "dense",
						InputProps: {
							style: {
								height: cmmsTheme.dimensions.standardInput,
								marginTop: cmmsTheme.spacing.inputOffset,
							},
						},
						InputLabelProps: {
							style: {
								fontSize: "14px",
							},
						},
					},
				}}
			/>
		</LocalizationProvider>
	);
};
